import { createApiClient } from 'Network/ApiClient';

export const DrugsAllowedDrugsAxiosInstance = createApiClient('Drugs/');


